export default "__VITE_ASSET__Bt4KT2PC__"